<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Lieferant bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="supplier.permalink" target="_blank">{{ supplier.permalink }}</a>
        </p>

        <div class="d-flex justify-content-between">
            <div class="mb-4">
                <inertia-link :href="route('admin.users.index', {})" class="btn btn-outline-secondary">
                    {{ __('Benutzer verwalten') }}
                </inertia-link>
                <inertia-link :href="route('admin.users.create', {account_id: supplier.id})" class="btn btn-outline-secondary">
                    {{ __('Benutzer erstellen') }}
                </inertia-link>
            </div>
        </div>

        <form @submit.prevent="form.put(route('admin.suppliers.update', supplier))">
            <form-fields :form="form" 
                         :supplier="supplier"
                         :countries="countries"
                         :supplier-groups="supplierGroups"
                         :import-mode-options="importModeOptions"
                         :import-type-options="importTypeOptions"
                         :price-type-options="priceTypeOptions" 
                         />
        </form>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplier',
            'countries',
            'supplierGroups',
            'priceTypeOptions',
            'importModeOptions',
            'importTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    enabled: this.supplier.enabled,
                    country_id: this.supplier.country_id,
                    supplier_group_id: this.supplier.supplier_group_id,
                    name: this.supplier.name,
                    slug: this.supplier.slug,
                    short_name: this.supplier.short_name,
                    logo: this.supplier.logo,
                    default_product_image_id: this.supplier.default_product_image_id,
                    gln: this.supplier.gln,
                    street: this.supplier.street,
                    house_number: this.supplier.house_number,
                    zip_code: this.supplier.zip_code,
                    city: this.supplier.city,
                    phone: this.supplier.phone,
                    fax: this.supplier.fax,
                    email: this.supplier.email,
                    order_email: this.supplier.order_email,
                    contact_email: this.supplier.contact_email,
                    register_number: this.supplier.register_number,
                    default_product_price_type: this.supplier.default_product_price_type,
                    general_product_price: this.supplier.general_product_price,
                    general_product_price_text: this.supplier.general_product_price_text,
                    vat_id: this.supplier.vat_id,
                    website: this.supplier.website,
                    terms_url: this.supplier.terms_url,
                    meta_title: this.supplier.meta_title,
                    meta_description: this.supplier.meta_description,
                    description: this.supplier.description,
                    notes: this.supplier.notes,
                    scoring: this.supplier.scoring,
                    import_mode: this.supplier.import_mode,
                    default_import_type: this.supplier.default_import_type,
                    account_options: {
                        document_default_content: this.supplier.account_options.document_default_content,
                        allow_order_despite_empty_stock: this.supplier.account_options.allow_order_despite_empty_stock,
                        customers_must_have_relation: this.supplier.account_options.customers_must_have_relation,
                        customers_must_have_relation_url: this.supplier.account_options.customers_must_have_relation_url,
                    },
                }),
            }
        },
        computed: {

        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>